import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
       // marginBottom: 5,
        marginTop: 5,
        borderBottomColor: '#000',
        borderBottomWidth: 1,
    },
    
  });


  const InvoiceLine = () => (
    <View style={styles.titleContainer}>
    </View>
  );
  
  export default InvoiceLine